import { blackColor, blackColors } from 'assets/jss/material-dashboard-pro-react';

const customConfirmationDialogStyle = (theme) => ({
	dialog: ({ width }) => ({
		'& .MuiPaper-root': {
			padding: '16px',
			width: `${width || 300}px`,
			maxWidth: '80%',
		},
	}),
	center: ({ isNewDashBoardEnabled }) => ({
		textAlign: 'center',
		marginTop: isNewDashBoardEnabled ? '1rem' : 0,
	}),
	bodyWrapper: ({ padding }) => ({
		padding: `${padding || '0 16px'}`,
		textAlign: 'center',
		[theme.breakpoints.down('xs')]: {
			padding: '0 16px',
		},
	}),
	dialogCloseButton: ({ isNewDashBoardEnabled }) => ({
		background: 'transparent',
		border: 'none',
		display: 'flex',
		padding: 0,
		alignItems: 'center',
		cursor: 'pointer',
		marginLeft: 'auto',
		marginRight: 0,
		'& svg': {
			fontSize: '24px',
			color: isNewDashBoardEnabled ? blackColor : blackColors[3],
		},
	}),
	iconWrapper: ({ isNewDashBoardEnabled }) => ({
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-start',
		alignItems: 'center',
		marginBottom: isNewDashBoardEnabled ? '0.5rem' : '24px',
		fontWeight: isNewDashBoardEnabled ? 700 : 400,
		fontSize: isNewDashBoardEnabled ? theme.fontSize(16) : theme.fontSize(14),
		'& img': {
			width: ' 64px',
			height: '64px',
			marginBottom: isNewDashBoardEnabled ? '1rem' : '24px',
		},
	}),
	withoutIcon: {
		marginBottom: 0,
	},
});

export default customConfirmationDialogStyle;
